import type { Listener } from './types'

export const listeners = new Map<symbol, Listener>()

export function addAnalyticListener(listener: Listener): symbol {
  const id = Symbol('analyticListener')
  listeners.set(id, listener)
  return id
}

export function removeAnalyticListener(id: symbol): void {
  listeners.delete(id)
}
